import React from 'react'
import { Card, CardProps } from '@mui/material'

const MuiCard: React.FC<CardProps> = ({ ...props }: CardProps) => {
  return <Card elevation={4} {...props} />
}

export default MuiCard
